import axios from 'axios';

const inferBase = () => {
  if (process.env.REACT_APP_API_BASE) return process.env.REACT_APP_API_BASE;
  try {
    const host = window.location.hostname;
    if (host.includes('karnidigitalsolutions.com')) {
      return 'https://api.karnidigitalsolutions.com/api';
    }
  } catch {}
  return 'http://localhost/karnidigitalsolutions/backend/public/api';
};

const API_BASE_URL = inferBase();

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Add token to requests
api.interceptors.request.use(config => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle errors
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      // Don't redirect on login page
      const isLoginPage = window.location.pathname.includes('/admin/login');
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
      if (!isLoginPage) {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
